<template>
  <div class="ccs-layout">
    <div class="ccs-layout css-12 ccs-layout--no-pad">
      <ccs-input class="ccs-6" v-model.trim="fieldsValues.departure_point"
        v-bind="fieldsDefinitions.departure_point"
        @error="(err) => setFieldError('departure_point', err)"/>
      <ccs-input class="ccs-6" v-model.trim="fieldsValues.arrival_point"
        v-bind="fieldsDefinitions.arrival_point"
        @error="(err) => setFieldError('arrival_point', err)"/>
      <ccs-input class="ccs-3" v-model.trim="fieldsValues.departure_date"
        v-bind="fieldsDefinitions.departure_date"
        @error="(err) => setFieldError('departure_date', err)"/>
      <ccs-input class="ccs-3" v-model.trim="fieldsValues.departure_time"
        v-bind="fieldsDefinitions.departure_time"
        @error="(err) => setFieldError('departure_time', err)"/>
      <ccs-input class="ccs-3" v-model.trim="fieldsValues.arrival_date"
        v-bind="fieldsDefinitions.arrival_date"
        @error="(err) => setFieldError('arrival_date', err)"/>
      <ccs-input class="ccs-3" v-model.trim="fieldsValues.arrival_time"
        v-bind="fieldsDefinitions.arrival_time"
        @error="(err) => setFieldError('arrival_time', err)"/>
      <ccs-input class="ccs-4" v-model.trim="fieldsValues.transport_type"
        v-bind="fieldsDefinitions.transport_type"
        @error="(err) => setFieldError('transport_type', err)"/>
      <ccs-input class="ccs-4" v-model.trim="fieldsValues.transport_make"
        v-bind="fieldsDefinitions.transport_make"
        @error="(err) => setFieldError('transport_make', err)"/>
      <ccs-input class="ccs-4" v-model.trim="fieldsValues.transport_number"
        v-bind="fieldsDefinitions.transport_number"
        @error="(err) => setFieldError('transport_number', err)"/>
      <ccs-input class="ccs-12" v-model.trim="fieldsValues.description"
        v-bind="fieldsDefinitions.description"
        @error="(err) => setFieldError('description', err)"/>
    </div>
    <div class="ccs-layout ccs-layout--no-pad">
      <div>
        <button class="ccs-button" @click="submit">
          Сохранить изменения
        </button>
      </div>
      <div v-if="isEditing && permissionsStatus.isTransferDeleteAllowed">
        <button class="ccs-button ccs-button--blight ccs-button--delete"
          @click="removeTransfer">
          Удалить
        </button>
      </div>
      <div>
        <button class="ccs-button ccs-button--light" @click="$emit('close')">
          Отмена
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';

import FormHelper from '@/mixins/FormHelper.js';

import Input from '@/components/forms/Input.vue';

export default {
  name: 'Transfer',
  mixins: [FormHelper],
  components: {
    'ccs-input': Input,
  },
  data() {
    return {
      fieldsDefinitions: {
        departure_point: {
          isValid: false,
          error: '',
          required: true,
          type: "text",
          label: "Место отправления",
          placeholder: "Введите адрес/название",
        },
        arrival_point: {
          isValid: false,
          error: '',
          required: true,
          type: "text",
          label: "Место пирбытия",
          placeholder: "Введите адрес/название",
        },
        departure_date: {
          isValid: false,
          error: '',
          required: true,
          type: "date",
          label: "Дата отправления",
        },
        departure_time: {
          isValid: false,
          error: '',
          required: true,
          type: "time",
          label: "Время отправления",
        },
        arrival_date: {
          isValid: false,
          error: '',
          required: true,
          type: "date",
          label: "Дата прибытия",
        },
        arrival_time: {
          isValid: false,
          error: '',
          required: true,
          type: "time",
          label: "Время прибытия",
        },
        transport_type: {
          isValid: false,
          error: '',
          required: true,
          type: "text",
          label: "Тип транспорта",
          placeholder: "Введите тип",
        },
        transport_make: {
          isValid: false,
          error: '',
          required: true,
          type: "text",
          label: "Марка транспорта",
          placeholder: "Введите марку",
        },
        transport_number: {
          isValid: false,
          error: '',
          required: true,
          type: "text",
          label: "Номер транспорта",
          placeholder: "Введите номер",
        },
        description: {
          isValid: false,
          error: '',
          required: false,
          type: "textarea",
          label: "Описание",
          placeholder: "Введите описание",
        },
      },
      fieldsValues: {
        departure_point: '',
        arrival_point: '',
        departure_date: new Date(),
        departure_time: '',
        arrival_date: new Date(),
        arrival_time: '',
        transport_type: '',
        transport_make: '',
        transport_number: '',
        description: '',
      },
    }
  },
  props: {
    data: {
      type: Object,
      default: () => {
        return undefined;
      },
    },
  },
  computed: {
    ...mapState('events', ['event']),
    ...mapGetters('session', ['permissionsStatus']),
    isEditing() {
      return !!this.$props.data && !!this.$props.data.id;
    }
  },
  methods: {
    ...mapActions('events', ['createTransfer', 'updateTransfer', 'deleteTransfer']),
    getTimeFromDate(date) {
      let hours = date.getHours();
      let minutes = date.getMinutes();
      if (hours < 10) hours = `0${hours}`;
      if (minutes < 10) minutes = `0${minutes}`;
      return `${hours}:${minutes}`
    },
    mergeDateAndTime(rawDate, rawTime) {
      const date = new Date(rawDate);
      const time = `${rawTime}:00`;
      return `${date.getFullYear()}-${date.getMonth()+1}-${date.getDate()} ${time}`;
    },
    async submit() {
      this.validateForm();
      if (this.isFormValid) {
        if (this.fieldsValues.id) {
          await this.editTransfer();
        } else {
          await this.addTransfer();
        }
      }
    },
    async addTransfer() {
      this.fieldsValues.event_id = this.event.id;
      this.fieldsValues.departure_date = this.mergeDateAndTime(
        this.fieldsValues.departure_date,
        this.fieldsValues.departure_time,
      );
      this.fieldsValues.arrival_date = this.mergeDateAndTime(
        this.fieldsValues.arrival_date,
        this.fieldsValues.arrival_time,
      );
      try {
        await this.createTransfer(this.fieldsValues);
        this.$toasted.success('Трансфер добавлен');
        this.$emit('close');
      } catch (err) {
        this.showServerValidationErrors(err);
      }
    },
    async editTransfer() {
      this.fieldsValues.departure_date = this.mergeDateAndTime(
        this.fieldsValues.departure_date,
        this.fieldsValues.departure_time,
      );
      this.fieldsValues.arrival_date = this.mergeDateAndTime(
        this.fieldsValues.arrival_date,
        this.fieldsValues.arrival_time,
      );
      const originArrivalDate = new Date(this.$props.data.arrival_date);
      const originArrivalTime = this.getTimeFromDate(originArrivalDate);
      const originDepartureDate = new Date(this.$props.data.departure_date);
      const originDepartureTime = this.getTimeFromDate(originDepartureDate);
      const changedFields = this.getChangedFields({
        ...this.$props.data,
          arrival_date: this.mergeDateAndTime(originArrivalDate, originArrivalTime),
          departure_date: this.mergeDateAndTime(originDepartureDate, originDepartureTime),
          arrival_time: this.fieldsValues.arrival_time,
          departure_time: this.fieldsValues.departure_time,
      });
      try {
        if (Object.keys(changedFields).length > 0) {
          await this.updateTransfer({
            ...changedFields,
            id: this.fieldsValues.id,
          });
          this.$toasted.success('Изменения сохранены');
          this.$emit('close');
        }
      } catch (err) {
        this.showServerValidationErrors(err);
      }
    },
    async removeTransfer() {
      try {
        await this.deleteTransfer(this.fieldsValues.id);
        this.$toasted.success('Трансфер удалён');
        this.$emit('close');
      } catch (err) {
        this.$toasted.error(err.message);
      }
    },
  },
  mounted() {
    if (this.$props.data && this.$props.data.id) {
      this.fieldsValues = Object.assign({}, this.$props.data);
      let departure_date = new Date(this.$props.data.departure_date);
      let arrival_date = new Date(this.$props.data.arrival_date);
      this.fieldsValues.departure_time = this.getTimeFromDate(departure_date);
      this.fieldsValues.arrival_time = this.getTimeFromDate(arrival_date);
    }
  },
}
</script>
